import request from './request'
const custom = 'CUSTOMER-SERVE'

export function login(data) {
  return request({
    url: custom + '/user-verify/login',
    method: 'post',
    data
  })
}

export function loginByPhone(data) {
  return request({
    url: custom + '/sso/loginByPhone',
    method: 'post',
    data
  })
}

export function QFlogin(data) {
  return request({
    url: custom + '/QWLogin/login',
    method: 'post',
    data
  })
}

export function Becenterlogin(data) {
  return request({
    url: custom + '/sso/login',
    method: 'post',
    data
  })
}

export function Wxlogin(data) {
  return request({
    url: custom + '/sso/wx_login',
    method: 'post',
    data
  })
}

export function getVerCode(data) {
  return request({
    url: custom + '/user-verify/getVerCode',
    method: 'post',
    data
  })
}

export function getPhoneVerifyCode(data) {
  return request({
    url: custom + '/sso/getPhoneVerifyCode',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: custom + '/user-verify/infoTemp',
    method: 'get'
  })
}

export function findList(data) {
  return request({
    url: custom + '/auth/user-info/findList',
    method: 'post',
    data
  })
}

export function getOrgTree() {
  return request({
    url: custom + '/auth/user-info/getOrgTree',
    method: 'get'
  })
}

export function getFirstLevelIds() {
  return request({
    url: custom + '/auth/user-info/getFirstLevelIds',
    method: 'get'
  })
}

export function saveUserInfo(data) {
  return request({
    url: custom + '/auth/user-info/saveUserInfo',
    method: 'post',
    data
  })
}

export function add() {
  return request({
    url: custom + '/auth/user-info/add',
    method: 'post'
  })
}

export function exportData(data) {
  return request({
    url: custom + '/auth/user-info/export',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: custom + '/user-verify/logout',
    method: 'post'
  })
}
// 显示角色数据数据
export function getSysRoleList(data) {
  return request({
    url: custom + '/sys-role/findRoleList',
    method: 'post',
    data
  })
}
// 显示角色数据数据
export function findMenusTree() {
  return request({
    url: custom + '/sys-role/findMenusTree',
    method: 'get'
  })
}
// 添加角色
export function addSysRole(data) {
  return request({
    url: custom + '/sys-role/addSysRole',
    method: 'post',
    data
  })
}
// 修改角色
export function upDateSysRole(data) {
  return request({
    url: custom + '/sys-role/upDateSysRole',
    method: 'post',
    data
  })
}
// 删除角色
export function deleteSysRole(data) {
  return request({
    url: custom + '/sys-role/deleteSysRole',
    method: 'post',
    data
  })
}

export function changeUserPasswd(data) {
  return request({
    url: custom + '/user-verify/changeUserPasswd',
    method: 'post',
    data
  })
}
// 菜单树
export function getfindPermissionList(data) {
  return request({
    url: custom + '/permission-menu/findPermissionList',
    method: 'post',
    data
  })
}

// 菜单列表数据
export function getfindPermissionJSONList(data) {
  return request({
    url: custom + '/permission-menu/findPermissionJSONList',
    method: 'post',
    data
  })
}

// 菜单列表数据
export function findMenusList(data) {
  return request({
    url: custom + '/permission-menu/findMenusList',
    method: 'post',
    data
  })
}

// 绑定角色与菜单权限关系
export function addRolePermissionMenu(data) {
  return request({
    url: custom + '/sys-role-permission-menu/addRolePermissionMenu',
    method: 'post',
    data
  })
}

export function updateRoleMenus(data) {
  return request({
    url: custom + '/sys-role-permission-menu/updateRoleMenus',
    method: 'post',
    data
  })
}

export function findRoleUsers(data) {
  return request({
    url: custom + '/sys-role/findRoleUsers',
    method: 'post',
    data
  })
}

// 绑定用户与角色的关系
export function saveUserSysRole(data) {
  return request({
    url: custom + '/sys-role/saveUserSysRole',
    method: 'post',
    data
  })
}

// 菜单列表添加
export function getaddPermissionMenu(data) {
  return request({
    url: custom + '/permission-menu/addPermissionMenu',
    method: 'post',
    data
  })
}

// 修改密码，参数对称加密
export function modifyPwd(data) {
  return request({
    url: custom + '/auth/user-info/modifyPwd?password=' + data,
    method: 'get'
  })
}

export function userAdd(data) {
  return request({
    url: custom + '/auth/user-info/add',
    method: 'post',
    data
  })
}

export function nameToAccout(data) {
  return request({
    url: custom + '/auth/user-info/nameToAccount?name=' + data,
    method: 'get'
  })
}

export function getUserDataRiht(data) {
  return request({
    url: custom + '/user-power/findPowerDealerIds',
    method: 'post',
    data
  })
}

export function getOriganizationDataTree() {
  return request({
    url: custom + '/isolation-object/findOrganizationTree',
    method: 'post'
  })
}
export function resetPwd(id, domain) {
  return request({
    url: custom + '/auth/user-info/reset?id=' + id + '&domain=' + domain,
    method: 'get'
  })
}

// 菜单列表删除
export function deletePermissionMenu(data) {
  return request({
    url: custom + '/permission-menu/deletePermissionMenu',
    method: 'post',
    data
  })
}

// 菜单修改权限
export function updatePermissionMenu(data) {
  return request({
    url: custom + '/permission-menu/updatePermissionMenu',
    method: 'post',
    data
  })
}

export function updateMenu(data) {
  return request({
    url: custom + '/permission-menu/updateMenu',
    method: 'post',
    data
  })
}
// 获取角色详情
export function findById(data) {
  return request({
    url: custom + '/sys-role/findById',
    method: 'post',
    data
  })
}
// 获取角色详情
export function findMenuById(data) {
  return request({
    url: custom + '/permission-menu/findById',
    method: 'post',
    data
  })
}
